
import { useEffect, useRef } from 'react';
import { activityData } from '../../../mocks/activityData';

export default function LiveActivityStream() {
  const streamRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const stream = streamRef.current;
    if (!stream) return;

    let scrollPosition = 0;
    const scrollSpeed = 0.5;

    const animate = () => {
      scrollPosition += scrollSpeed;
      
      if (scrollPosition >= stream.scrollHeight / 2) {
        scrollPosition = 0;
      }
      
      stream.scrollTop = scrollPosition;
      requestAnimationFrame(animate);
    };

    const animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, []);

  // Get activity type styling
  const getActivityStyle = (type?: string) => {
    switch (type) {
      case 'ai-detection':
        return 'bg-purple-500/10 border-l-2 border-purple-400';
      case 'ai-recommendation':
        return 'bg-blue-500/10 border-l-2 border-blue-400';
      case 'ai-action':
        return 'bg-cyan-500/10 border-l-2 border-cyan-400';
      case 'ai-resolution':
        return 'bg-emerald-500/10 border-l-2 border-emerald-400';
      default:
        return '';
    }
  };

  const getTextColor = (type?: string) => {
    switch (type) {
      case 'ai-detection':
        return 'text-purple-300';
      case 'ai-recommendation':
        return 'text-blue-300';
      case 'ai-action':
        return 'text-cyan-300';
      case 'ai-resolution':
        return 'text-emerald-300';
      default:
        return 'text-gray-300';
    }
  };

  return (
    <div className="absolute right-8 bottom-8 z-30 w-[252px]">
      <div className="bg-[#0f172a]/40 backdrop-blur-sm border border-blue-500/20 rounded-lg overflow-hidden">
        <div className="px-2.5 py-2 border-b border-blue-500/20 bg-[#1e293b]/50">
          <h3 className="text-[7px] font-semibold text-blue-300 uppercase tracking-wider">
            Live Global Data Activity Stream
          </h3>
        </div>
        
        <div 
          ref={streamRef}
          className="h-[336px] overflow-hidden"
          style={{ scrollBehavior: 'auto' }}
        >
          <div className="space-y-0">
            {/* Render data twice for seamless loop */}
            {[...activityData, ...activityData].map((activity, index) => (
              <div 
                key={index}
                className={`px-2.5 py-1.5 border-b border-gray-800/30 hover:bg-blue-500/5 transition-colors ${getActivityStyle(activity.type)}`}
              >
                <div className={`text-[7px] font-mono leading-relaxed ${getTextColor(activity.type)}`}>
                  {activity.text}
                </div>
                <div className="text-[6px] text-gray-500 mt-0.5 font-mono">
                  {activity.timestamp}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
